import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

import { ColorTypes, RadiusTypes, SpacingTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

interface IWrapperProps {
	borderless?: boolean;
	bgColor?: ColorTypes;
	borderColor?: ColorTypes;
	className?: string;
	clickable?: boolean;
	footerMargin?: SpacingTypes;
	hasFooter?: boolean;
	hasHeader?: boolean;
	headerMargin?: SpacingTypes;
	padding?: SpacingTypes;
	radius?: RadiusTypes;
	shadow?: boolean;
}

export interface ICardProps extends IWrapperProps {
	header?: ReactNode;
	body?: ReactNode;
	footer?: ReactNode;
	children?: ReactNode;
	onClick?: () => void;
}

const Wrapper = styled(FlexColumn)<IWrapperProps>`
	border: ${({ borderless, borderColor }) =>
		!borderless && `1px solid ${borderColor ?? theme.colors.black}`};
	padding: ${({ borderless, padding }) =>
		padding ? theme.spacing[padding] : !borderless && theme.spacing.md};
	background: ${({ bgColor }) => theme.colors[bgColor ?? 'transparent']};
	border-radius: ${({ radius }) => radius && theme.radius[radius]};
	box-shadow: ${({ shadow }) => (shadow ? theme.shadow.msspBox : null)};
	cursor: ${({ clickable }) => clickable && 'pointer'};

	> :first-child {
		margin-bottom: ${({ hasHeader, headerMargin = 'xs' }) =>
			hasHeader ? theme.spacing?.[headerMargin] ?? theme.spacing.xs : null};
	}

	> :last-child {
		margin-top: ${({ hasFooter, footerMargin = 'lg' }) =>
			hasFooter ? theme.spacing?.[footerMargin] ?? theme.spacing.lg : null};
	}
`;

const BaseCard: FC<ICardProps> = ({
	bgColor,
	borderColor,
	body,
	borderless,
	children,
	className,
	clickable,
	footer,
	footerMargin,
	header,
	headerMargin,
	padding,
	radius,
	shadow,
	onClick,
}) => {
	return (
		<Wrapper
			borderless={borderless}
			borderColor={borderColor}
			bgColor={bgColor}
			clickable={clickable}
			className={className}
			footerMargin={footerMargin}
			headerMargin={headerMargin}
			padding={padding}
			radius={radius}
			shadow={shadow}
			hasHeader={!!header}
			onClick={onClick}
			hasFooter={!!footer}>
			{header}
			{body ?? children}
			{footer}
		</Wrapper>
	);
};

export default styled(BaseCard)``;
